interface Config {
    title: string;
    theme: string;
    email: string;
    address: string;
    location: string;
    map: string;
    center: string;
    socials: {
        facebook: string;
        instagram: string;
    };
    privacy: {
        authorizedPerson: string
        company: {
            name: string,
            address: string,
            cin: string;
            vat: string;
        }
        facility: {
            address: string,
        }
        account: string,
        registration: {
            name: string,
            section: string,
            insert: string
        },
        contact: {
            phone: string,
            mail: string
        }
    }
}

const config: Config = (window as any).APP_CONFIG || {
    "title": "Motokáry Martin",
    "theme": "blue",
    "email": "info@motokaryzilina.sk",
    "address": "Robotnícka 14, (Areál ZŤS), Martin",
    "location": "martin",
    "map": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d943.8640559919273!2d18.90910913749153!3d49.06623644357431!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4714fed11ed2a46b%3A0xcb51cf78f8572488!2sMotok%C3%A1ry%20Martin!5e0!3m2!1ssk!2scz!4v1765273696576!5m2!1ssk!2scz",
    "center": "852",
    "socials": {
        "facebook": "https://www.facebook.com/motokarymartin",
        "instagram": "https://www.instagram.com/motokary.martin"
    },
    "privacy": {
        "authorizedPerson": "Lukáš Tamáš",
        "company": {
            "name": "AD GO s.r.o",
            "address": "Langsfeldova 5402/1, 036 01 Martin",
            "cin": "57 402 779",
            "vat": "2122707015"
        },
        "facility": {
            "address": "Robotnícka 10287, 036 01 Martin",
        },
        "account": "IBAN: SK39 1100 0000 0029 4630 1858",
        "registration": {
            "name": "Obchodný register Okresného súdu Žilina",
            "section": "Sro",
            "insert": "91529/L"
        },
        "contact": {
            "phone": "+421 940 548 131",
            "mail": "motokarymartin@motokarymartin.sk"
        }
    }
};

export default config;
